import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';
import { AdminService } from 'src/app/services/admin.service';
import { TextHelper } from 'src/app/helpers';
import { FormGroup, FormControl } from '@angular/forms';
import { GlobalErrorsHandler } from 'src/app/core/errors/global-errors.handler';

@Component({
  selector: 'app-invite-users-dialog',
  templateUrl: './invite-users-dialog.component.html',
  styleUrls: ['./invite-users-dialog.component.css']
})
export class InviteUsersDialogComponent implements OnInit, OnDestroy {
  link!: string;
  sending = false;

  success?: string;
  error?: string;

  form!: FormGroup;

  get recipients() { return this.form.get('recipients') as FormControl; }

  constructor(
    private dialogRef: MatDialogRef<InviteUsersDialogComponent>,
    private adminService: AdminService,
    private clipboard: Clipboard,
    private errorsHandler: GlobalErrorsHandler
  ) { }

  ngOnInit(): void {
    this.errorsHandler.ignore = true; // handle locally in popup
    this.initForm();
    this.generateLink();
  }

  ngOnDestroy(): void {
    this.errorsHandler.ignore = false;
  }

  private initForm(): void {
    this.form = new FormGroup({
      recipients: new FormControl()
    });
  }

  private async generateLink() {
    this.link = await this.adminService.getInvitationLink().toPromise();
  }

  async copyLink() {
    try {
      if (!this.link) {
        return;
      }

      const copied = await TextHelper.copy(this.link, this.clipboard);

      if (copied) {
        this.success = 'Link copied to clipboard.';
      }
      else {
        this.showError('Failed to copy link to clipboard.');
      }
    } catch (err) {
      console.error(err);
      this.showError('Failed to copy link to clipboard.');
    }
  }

  async sendInvitations(f: any) {
    if (this.sending) {
      return;
    }

    try {
      this.sending = true;
      this.clearMessage();

      const emails = this.recipients.value.split(/[,;\s\n]+/g);

      if (emails.length === 0) {
        this.sending = false;
        this.showError('Invalid emails entered.');
        return;
      }

      const res: any = await this.adminService.sendInvitations(emails).toPromise().catch(error => {
        console.error(error);
        return error?.body?.message ? error.body : { success: false };
      });

      // Success
      if (res.success) {
        this.dialogRef.close(res);
      }
      // Error
      else {
        this.sending = false;
        this.showError(res.message || 'Failed to send invitations.');
      }
    }
    catch (err) {
      console.error(err);
      this.sending = false;
      this.showError('Failed to send invitations.');
    }
  }

  close() {
    this.dialogRef.close();
  }

  private clearMessage() {
    this.success = '';
    this.error   = '';
  }

  private showError(msg: string) {
    this.success = '';
    this.error = msg;
    setTimeout(() => this.clearMessage(), 3000);
  }
}
